import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { DeepLinkingService } from '@app/@shared/services/deep-linking.service';

@Injectable({
  providedIn: 'root'
})
export class ClientErrorHandlerInterceptor implements HttpInterceptor {

  constructor(private router: Router, private deepLinkingService: DeepLinkingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((error) => this.handleError(error)));
  }


  private handleError(error: HttpEvent<any>): Observable<HttpEvent<any>> {
    const {url, status} = error as any;
    const redirectedUrls = environment.clientErrorRedirect;
    const nonEntitledRedirectUrls  = environment.nonEntitledErrorRedirect;
    if(nonEntitledRedirectUrls.some((value) => url.includes(value)) && status === 403) {
      this.deepLinkingService.redirectTo403()
    }
    /**
     * Temporarily we will be navigating user to 404 page when these endpoint return a 500
     * At somepoint a dedicated page will be created
     */
    if(redirectedUrls.some((value) => url.includes(value)) && (status === 404 || status === 500)) {
      this.router.navigate([ '/404' ]);
    }

    throw error;
  }
}
